import { api, pdfUrl } from "./api/client";
import React from "react";
import axios from "axios";
import MUIDataTable from "mui-datatables";
import {createTheme, MuiThemeProvider} from "@material-ui/core/styles";
import {utils, write} from "xlsx";
import { saveAs } from 'file-saver'
import moment from "moment";

import Select from "react-select";
import Button from "@mui/material/Button";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import { enhanceColumns, withTableOptions } from "./utils/tableDisplay";

class ExpandableRowEntry extends React.Component {
    rows;
    lokasyonlarRows;
    technologyList = [];
    constructor(props) {
        super(props);
        this.state={childRows:[], childRowId:0,locations:[]};
        this.getDatas();

    }

    async getDatas() {
        console.log(this.props.rowData[0].props.children[1]);
        const uyfNo = this.props.rowData[0].props.children[1];
        const row = await api.get('/teklifler', {
            params: {
                uyf_no: uyfNo,
                page: 1,
                page_size: 200,
            }
        });

        const raw = row.data;
        this.rows = Array.isArray(raw) ? raw : (raw?.items || raw?.data || []);

        const machines = this.rows.map(d => ({
            "id":d.id ,
            "teklif_no" :  d.teklif_no,
            "teklif_tarihi":d.teklif_tarihi ,
            "teslim_tarihi" : d.teslim_tarihi ,
            "musteri" :  d.musteri,
            "lokasyon": d.lokasyon,
            "uyf_no" :  d.uyf_no,
            "makine" :  d.makine,
            "dosya_bir": d.dosya_bir,
            "dosya_iki" : d.dosya_iki,
            "dosya_uc" : d.dosya_uc,
            "temsilci": d.temsilci,
            "onay": d.onay,
            "son_teslim_tarihi": d.son_teslim_tarihi
        }))
        //console.log(products);
        this.setState({childRows: machines})


               // for machine location update
               const lokasyonlars = await api.get('/lookups/lokasyonlar', {
                   params: {
                       musteri_id:machines[0].musteri_id
                }
               } );

               this.lokasyonlarRows=lokasyonlars.data;
               const locations = this.lokasyonlarRows.map(d => (
                   this.technologyList.push({
                       label: d.lokasyon_adi,
                       value: d.lokasyon_id
                   })
               ))

               await this.setState({locations: lokasyonlars.data})
               console.log("location",this.state.locations);



    }

    async changeLocation(locationID, machineID) {

        await api.get('/lookups/makineler/' + machineID + '/lokasyon', {
            params: {
                lokasyon_id: locationID,
            }
        })
            .then((response) => {
                // Success 🎉
                console.log(response);
                this.getDatas();
            })
            .catch((error) => {
                // Error 😨
                if (error.response) {
                    /*
                     * The request was made and the server responded with a
                     * status code that falls out of the range of 2xx
                     */
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    /*
                     * The request was made but no response was received, `error.request`
                     * is an instance of XMLHttpRequest in the browser and an instance
                     * of http.ClientRequest in Node.js
                     */
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request and triggered an Error
                    console.log('Error', error.message);
                }
                console.log(error.config);
            });

    }


    render() {
        let datas=[];
        const options = {
            filter: false,
            onFilterChange: (changedColumn, filterList) => {
                //console.log(changedColumn, filterList);
            },
            selectableRows: false,
            filterType: 'multiselect',
            responsive: "vertical",
            rowsPerPage: 100,
            fixedHeader: true,
            //fixedSelectColumn: true,
            tableBodyHeight: '50%',
            print:false,
            download:true,
            draggableColumns: {
                enabled:true,
                transitionTime:400
            },
            rowStyle: {
                fontSize: 9,
            },
            downloadOptions: {
                filterOptions: {
                    useDisplayedColumnsOnly: true,
                    useDisplayedRowsOnly: true
                }
            },
            onRowSelectionChange : (curRowSelected, allRowsSelected) => {
                datas.length=0;
                console.log("---RowSelect")
                console.log("Row Selected: ", curRowSelected);
                console.log("All Selected: ", allRowsSelected);

                if(allRowsSelected) {
                    allRowsSelected.forEach((result)=>{
                        datas.push(this.state.childRows[result.dataIndex]);
                    })
                }
            },
            textLabels :{
                selectedRows: {
                    text: "satır seçildi",
                    delete: "SiparişeEkle",
                    deleteAria: "Seçilenleri siparişe aktar",
                },
                pagination: {
                    next: "İleri",
                    previous: "Geri",
                    rowsPerPage: "Sayfadaki satır sayısı:",
                    displayRows: "/",
                },
                toolbar: {
                    search: "Ara",
                    downloadCsv: "XLSX İndir",
                    print: "Çıktı Al",
                    viewColumns: "Sütunları Göster",
                    filterTable: "Tabloyu Süz",
                },
                filter: {
                    all: "Tümünü Göster",
                    title: "Filtreler",
                    reset: "Sıfırla",
                },
                viewColumns: {
                    title: "Sütunları Göster",
                    titleAria: "Sütunları Göster/Gizle",
                },

            },
            onDownload: (buildHead, buildBody, columns, values) => {
                const fileType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                const fileExtension = ".xlsx";

                //console.log(values.forEach(val => console.log(val)));

                const json = values.reduce((result, val) => {
                    const temp = {};
                    val.data.forEach((v, idx) => {
                        temp[columns[idx].name] = v;
                    });
                    result.push(temp);
                    return result;
                }, []);

                const fileName = `Makine Listesi`;
                const ws = utils.json_to_sheet(json);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], { type: fileType });
                saveAs(data, fileName + fileExtension);
                // cancel default  CSV download from table
                return false;
            },
            expandableRows: false,


        };
        const myTheme  = createTheme({
            overrides: {

                MUIDataTableToolbar:{
                    root:{
                        display: "none"
                    }
                },
                MUIDataTableFooter:{
                    root:{
                        display: "none"
                    }
                },
                MuiTableCell: {
                    head: {
                        backgroundColor: "#e3a165 !important",
                        fontWeight: "bold",
                        padding:1,
                        lineHeight:0.1
                    },

                    root: {
                        lineHeight:0.5,
                        padding: '0px'
                    }
                },
                MUIDataTable: {

                    responsiveScroll: {
                        minHeight:'30vh',
                        width:'1200px',

                    },


                },
            },
        });

        const columns = [
            {
                name: "teklif_no",
                label: "Teklif No",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                <a href={pdfUrl(`teklif/${value}?mrp=true`)} target={'_blank'} rel="noreferrer">{value}</a>
                            );

                        }
                    },
                    //filterList: ['Franky Miles'],
                    customFilterListOptions: { render: v => `Teklif NO: ${v}` },
                },
            },
            {
                name: "teklif_tarihi",
                label: "Teklif Tarihi",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                moment(new Date(value)).format('DD/MM/yyyy')
                            );

                        }
                    },
                },
            },
            {
                name: "onay",
                label:"Durum",
                options: {
                    filter:false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value==='complete') {
                            return (<span>Tamamlanmış</span>);
                        }
                        else if(value==='false') {
                            return ( <span>Reddedilmiş</span>);
                        }
                        else if(value==='true') {
                            return (<span>Onaylanmış</span>);
                        }
                        else {
                            return (  <span>Onay bekliyor</span>);
                        }
                    },
                    sort:false,
                }
            },
            {
                name: "son_teslim_tarihi",
                label: "Teslim Tarihi",
                options: {
                    filter: false,
                    filterOptions: {
                        fullWidth: true
                    },
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                moment(new Date(value)).format('DD/MM/yyyy')
                            );

                        }
                    },
                }
            },

            {
                name: "dosya_bir",
                label:"D1",
                options: {
                    filter:false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                <a href={value} target="_blank">
                                    Aç
                                </a>
                            );

                        }
                    },
                    sort:false,
                }
            },
            {
                name: "dosya_iki",
                label:"D2",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                <a href={value} target="_blank">
                                    Aç
                                </a>
                            );

                        }
                    },
                    sort: false
                }
            },
            {
                name: "dosya_uc",
                label:"D3",
                options: {
                    filter: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        if (value) {
                            return (
                                <a href={value} target="_blank">
                                    Aç
                                </a>
                            );

                        }
                    },
                    sort: false
                }
            },

        ];

        return(<React.Fragment>

            <tr>
                <td colSpan={9}>
                    <MuiThemeProvider theme={myTheme}>
                        <MUIDataTable title={"Teklifler"} data={this.state.childRows} columns={enhanceColumns(columns)} options={withTableOptions(options)} />
                    </MuiThemeProvider>
                </td>
            </tr>

        </React.Fragment> )

    };

};

export default ExpandableRowEntry;
